import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ActivityIcon from 'common/ActivityIcon';
import RowItem from 'common/RowItem';

class ContentItem extends PureComponent {
  static defaultProps = {
    imageUrl: '',
    disabled: false,
  }

  static propTypes = {
    type: PropTypes.oneOf(['missing', 'badge', 'education', 'questionnaire', 'exercise']).isRequired,
    id: PropTypes.string.isRequired,
    completed: PropTypes.bool.isRequired,
    faded: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    imageUrl: PropTypes.string,
    disabled: PropTypes.bool,
  }

  renderLeftIcon = () => {
    const { type, imageUrl } = this.props;
    return <ActivityIcon type={type} imageUrl={imageUrl} />;
  }

  renderRightIcon = () => {
    const { completed } = this.props;
    if (completed) {
      return <i className="primary f2 fas fa-check-circle" />;
    }
    return <i className="primary f2 far fa-circle" />;
  }

  render() {
    const { disabled, id, faded, name, description } = this.props;
    const route = disabled ? '' : `/my_tasks/${id}/`;

    return (
      <RowItem
        path={route}
        faded={faded}
        disabled={disabled}
        renderLeftIcon={this.renderLeftIcon}
        renderRightIcon={this.renderRightIcon}
      >
        <span className="db mv2 f4">{name}</span>
        <span className="db mv2 f5">{description}</span>
      </RowItem>
    );
  }
}

export default ContentItem;
